import React, { useState } from 'react';

import Icon from 'eventbrite_design_system/icon/Icon';
import MagnifyingGlassChunkySvg from 'eventbrite_design_system/iconography/icons/MagnifyingGlassChunky';
import Button from 'eventbrite_design_system/button/Button';
import MapPinChunkySvg from 'eventbrite_design_system/iconography/icons/MapPinChunky';
import { gettext } from '@eb/i18n';
import { setWindowLocation } from 'js-utils/http';

import GlobalHeaderSearch, {
    getSearchInfo,
} from '../ConsumerHeader/GlobalHeaderSearch';
import ConnectedLocationSearchAutocomplete from '../../containers/ConnectedLocationSearchAutocomplete';

import './SearchAndLocationBar.scss';

const LOCATION_AUTOCOMPLETE_PROPS = {
    borderType: 'none',
    id: 'locationPicker',
    name: 'locationPicker',
    hideOutline: true,
    isLimitedSearch: true,
    preventInputValuePrefill: true,
    shouldRemoveConflictiveAria: true,
};

export default function SearchAndLocationBar(props) {
    const [currentSearchQuery, setCurrentSearchQuery] = useState(
        props.env.searchQuery || '',
    );
    const searchInfo = getSearchInfo(props.env.serverUrl, currentSearchQuery);

    return (
        <>
            <div className="search-and-location-bar__container">
                <div className="search-and-location-bar">
                    <GlobalHeaderSearch
                        id="home-desktop-search"
                        searchInfo={searchInfo}
                        onSubmit={props.handleSearch}
                        onSelect={setWindowLocation}
                        onChange={setCurrentSearchQuery}
                        containerClassName="search-and-location-bar__search-autocomplete-container"
                        formClassName="search-and-location-bar__search-autocomplete"
                        suffix={<></>}
                        hasMinAsideSpacing={true}
                    />
                    <div className="search-and-location-bar__divider" />
                    <ConnectedLocationSearchAutocomplete
                        autocompleteProps={LOCATION_AUTOCOMPLETE_PROPS}
                        shouldDispatchSearchActions={true}
                        prefix={
                            <Icon
                                type={<MapPinChunkySvg />}
                                color="ui-800"
                                strokeColor="ui-800"
                            />
                        }
                    />
                    <div
                        className="
                    search-and-location-bar__search-button
                    eds-l-mar-right-6
                    eds-hide-sn
                    eds-hide-sm
                    eds-hide-mn
                    eds-hide-md
                    eds-hide-mw
                    eds-hide-ln
                    eds-hide-lg
                    eds-hide-lw
                "
                    >
                        <Button
                            style="fill"
                            onClick={() =>
                                props.handleSearch(currentSearchQuery)
                            }
                            __containerClassName="search-and-location-bar__search-button--tablet"
                        >
                            <Icon type={<MagnifyingGlassChunkySvg />} />
                        </Button>
                    </div>
                    <div className="eds-show-up-mn search-and-location-bar__search-button eds-l-mar-right-6">
                        <Button
                            style="fill"
                            onClick={() =>
                                props.handleSearch(currentSearchQuery)
                            }
                        >
                            {gettext('Search')}
                        </Button>
                    </div>
                </div>
                <div className="eds-show-down-sm eds-l-mar-top-4 search-and-location-bar__search-button--mobile">
                    <Button
                        style="fill"
                        onClick={() => props.handleSearch(currentSearchQuery)}
                    >
                        {gettext('Search')}
                    </Button>
                </div>
            </div>
        </>
    );
}
